import { InjectionToken } from '@angular/core';

export const CURRENT_ENVIRONMENT = new InjectionToken<any>('CURRENT_ENVIRONMENT');
